// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__3v99y","checkbox":"Checkbox_checkbox__Xze9N","icon":"Checkbox_icon__3ETvu","iconShow":"Checkbox_iconShow__27Wro"};